import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'ageFromBirthday'
})
export class AgeFromBirthdayPipe implements PipeTransform {

  /**
   * Calcula la diferencia de tiempo exacta entre dos hoy y la fecha de nacimiento en años meses y días.
   * La diferencia es precisa al estilo calendario (no basada en promedios).
   * Si la diferencia supera los 3 años ya no mostrarán meses ni días.
   * @param value  fecha de nacimiento.
   * @returns Diferencia de tiempo exacta expresada en años, meses y días.
   */
  transform(value?: string | Date, limit = 999): string {
    if (!value) return '0 años';
    let ahora = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0});
    let nacimiento = moment(value).set({ hour: 0, minute: 0, second: 0, millisecond: 0});

    const anios = ahora.diff(nacimiento, 'years');
    nacimiento = nacimiento.add(anios, 'years');

    const meses = ahora.diff(nacimiento, 'months');
    nacimiento = nacimiento.add(meses, 'months');

    const dias = ahora.diff(nacimiento, 'days');
    
    return this.formatearDiferenciaDeTiempo(anios, meses, dias, limit);
  }

  /**
   * Genera una representación legible de una diferencia de tiempo dada en años, meses y días.
   * - Si el valor de años es mayor a 3, solo se muestra "3 años".
   * - Solo se muestran las unidades con valores mayores a 0.
   * - Usa correctamente singular/plural y conjunción "y" antes del último elemento.
   *
   * @param anios - Número de años
   * @param meses - Número de meses
   * @param dias - Número de días
   * @returns Texto formateado como "x años, y meses y z días"
   */
  private formatearDiferenciaDeTiempo(anios: number, meses: number, dias: number, limite: number): string {
    if (anios > limite) return `${anios} años`;

    const partes = [
      this.formatearUnidad(anios, 'año', 'años'),
      this.formatearUnidad(meses, 'mes', 'meses'),
      this.formatearUnidad(dias, 'día', 'dias')
    ];

    return partes.join(', ')/*.replace(/,([^,]*)$/, ' y$1') // Cambia la última coma por " y" */;
  }

  /**
   * Formatea una unidad de tiempo con su valor y su forma singular/plural.
   * Devuelve null si el valor es 0.
   *
   * @param valor - Cantidad de unidades
   * @param singular - Texto en singular (por ejemplo: 'año')
   * @param plural - Texto en plural (por ejemplo: 'años')
   * @returns La unidad formateada o null si el valor es 0
   */
  private formatearUnidad(valor: number, singular: string, plural: string): string | null {
    return valor > 0 ? `${valor} ${valor === 1 ? singular : plural}` : null;
  }

}
